// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2_kbh","header":"MergedInvoice_header__3Oyw9"};